import { LoadingOutlined } from '@ant-design/icons';
import { ReactComponent as ExportTicketIconInactive } from 'app/assets/img/export-excel-icon-inactive.svg';
import React, {
  MutableRefObject,
  RefObject,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';

import { Dropdown, Form } from 'antd';
import { ReactComponent as ArrowDownIcon } from 'app/assets/img/arrow-down-icon.svg';
import { ReactComponent as FilterIcon } from 'app/assets/img/filter-icon.svg';
import { LoadingContainer } from 'app/components/LoadingContainer';
import { StyledStack } from 'app/components/Stack';
import StyledButton from 'app/components/StyledButton';
import StyledTabs from 'app/components/StyledTabs';
import { Permission } from 'app/hooks/usePermission';
import useWindowSize from 'app/hooks/useWindowSize';
import {
  selectInfoUser,
  selectTranslations,
} from 'app/pages/App/slice/selectors';
import { GET_PARKS, useHomeSlice } from 'app/pages/Home/slice';
import { selectListPark } from 'app/pages/Home/slice/selectors';
import StyledSearchInput from 'app/pages/NewAccount/components/StyledSearchInput';
import StyledSelect, {
  MobileStyledSelect,
} from 'app/pages/NewAccount/components/StyledSelect';
import { ACCOUNT_MNG_MENU } from 'app/pages/NewAccount/layouts/AccountManager';
import { getDataAgentApi } from 'app/services/checkTicketApi';
import { isEmpty } from 'lodash-es';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { objectType } from 'types';
import { cleanObject } from 'utils/helper';
import { Layout } from '../layouts';
import ListOrderSuccess from './components/ListOrderSuccess';
import { ListTicketViewRef } from 'app/pages/NewAccount/types';
import DownLoadExcel from 'app/pages/Agent/TransactionHistory/_DownLoadExcel';
import { SESSION_MESSAGE } from 'utils/constants';
import { useGlobalFunction } from 'app/pages/App/hooks/useGlobalFunction';
import { getDayOfWeekString } from 'utils/time';
import styled from 'styled-components';
import { convertVItoEN } from '../CheckTickets/helper';
import RangeDatePickerCustom from '../CheckTickets/RangeDatePickerCustom';
import ListOrderPending from './components/ListOrderPending';
import ListOrderCancel from './components/ListOrderCancel';
import { selectOrderCount } from './slice/selectors';
import {
  exportListOrderExcelApi,
  getLOVpaymentMethod,
} from 'app/services/orderApi';
import { I_PayloadGetListOrder } from 'app/pages/Account/ListOrder/slice/types';

export enum ORDER_SOURCES {
  B2B = '0',
  API = '1',
}
export enum ISSUE_TICKET {
  PENDING = 'syncHoliday',
  ISSUED = 'success',
}

export enum TAB_ORDER_MANAGEMENT {
  THANH_CONG = 'THANH_CONG',
  CHO_THANH_TOAN = 'CHO_THANH_TOAN',
  DA_HUY = 'DA_HUY',
}

export const ORDER_SOURCE_OPTIONS = [
  { value: '', labelKey: 'b2b.text.all' },
  { value: ORDER_SOURCES.B2B, labelKey: 'b2b.order.source' },
  { value: ORDER_SOURCES.API, labelKey: 'b2b.order.api.source' },
];
export const ISSUE_TICKET_OPTIONS = [
  { value: '', labelKey: 'b2b.text.all' },
  { value: ISSUE_TICKET.PENDING, labelKey: 'b2b.txt.ticketPending' },
  { value: ISSUE_TICKET.ISSUED, labelKey: 'b2b.txt.ticketIssued' },
];
export enum HOLIDAY_COMBO_TYPES {
  FHT = 'FHT',
  FT = 'FT',
  FH = 'FH',
}
export const COMBO_TYPE_OPTIONS = [
  { value: '', labelKey: 'b2b.text.all' },
  {
    value: HOLIDAY_COMBO_TYPES.FHT,
    labelKey: 'b2b.txt.fhtCombo',
  },
  {
    value: HOLIDAY_COMBO_TYPES.FT,
    labelKey: 'b2b.txt.ftCombo',
  },
  {
    value: HOLIDAY_COMBO_TYPES.FH,
    labelKey: 'b2b.txt.fhCombo',
  },
];

type FilterDataView = {
  orderNumber: string;
  orderDateFrom: moment.Moment | null;
  orderDateTo: moment.Moment | null;
  agentId: string;
  searchParkID: string;
  successState: string;
  orderSource?: ORDER_SOURCES;
  paymentMethod?: number;
  issueTicket?: string;
  comboType?: HOLIDAY_COMBO_TYPES;
};

type SearchComponentProps = {
  travelLocation: {
    value: string;
    label: string;
  }[];
  searchSuccess: RefObject<ListTicketViewRef>;
  searchPendingPayment: RefObject<ListTicketViewRef>;
  searchCancel: RefObject<ListTicketViewRef>;
  setFilters?: (filters: Partial<FilterDataView>) => void;
  filters?: Partial<FilterDataView>;
  tab?: string;
  handleExportExcel?: () => void;
  listOrderType?: {
    value: string;
    label: any;
  }[];
  preventApiCall: boolean;
};

export const formatDate = (
  date: moment.Moment,
  translation: objectType | undefined,
) => {
  const dayOfWeek = getDayOfWeekString(date, translation);
  // Format the rest of the date
  return `${dayOfWeek} ${date.format('(DD/MM/YYYY)')}`;
};
const DesktopSearchComponent = ({
  travelLocation,
  searchSuccess,
  searchPendingPayment,
  searchCancel,
  tab,
  filters,
  setFilters,
  listOrderType,
  preventApiCall,
}: SearchComponentProps) => {
  const translations = useSelector(selectTranslations);
  const infoUser: any = useSelector(selectInfoUser);
  const isSaleMng =
    infoUser?.role_code === Permission.ROLE_SALE_MANAGER ||
    infoUser?.role_code === Permission.ROLE_SALE_SHG;
  const location = useLocation();
  const href = window.location.href;
  const searchParams = new URL(href).searchParams;
  const tabRoute =
    (location.state as any)?.targetTab ||
    searchParams.get('route') ||
    TAB_ORDER_MANAGEMENT.CHO_THANH_TOAN;
  const [dataAgent, setDataAgent] = useState([]);
  const [lovPaymentMethod, setLOVPaymentMethod] = useState<any[]>([]);
  const getDataAgent = useCallback(async () => {
    try {
      const { data } = await getDataAgentApi();
      if (!isEmpty(data?.data)) {
        const resAgents = data?.data.map((item: any) => {
          return {
            label: item.name,
            value: item.id,
          };
        });
        const resAgentsEx: any = isSaleMng
          ? [
              {
                value: '',
                label: translations?.['b2b.text.all'],
              },
              ...resAgents,
            ]
          : resAgents;
        setDataAgent(resAgentsEx);
      }
    } catch (error) {}
  }, [isSaleMng, translations]);

  const getPaymentMethod = useCallback(async () => {
    try {
      const { data } = await getLOVpaymentMethod();
      if (!isEmpty(data?.data)) {
        const lovpayment = data?.data.map((item: any) => {
          return {
            label: item.name,
            value: item.id,
          };
        });
        setLOVPaymentMethod([
          {
            value: '',
            label: translations?.['b2b.text.all'],
          },
          ...lovpayment,
        ]);
      }
    } catch (error) {}
  }, [translations]);

  useEffect(() => {
    if (preventApiCall) return;
    getDataAgent();
    getPaymentMethod();
  }, [getDataAgent, getPaymentMethod]);

  return (
    <Form
      style={{
        display: 'flex',
        marginBottom: 16,
      }}
    >
      <StyledStack direction={'column'} rowGap={'16px'}>
        <StyledStack columnGap={'18px'} justifyContent={'flex-start'}>
          <StyledSearchInput
            placeholder={
              translations ? translations['b2c.txt.orderNumber'] : ''
            }
            onChange={e =>
              setFilters?.({
                ...filters,
                orderNumber: e.target.value ?? '',
              })
            }
            onBlur={() => {
              setFilters?.({
                ...filters,
                orderNumber: filters?.orderNumber?.trim(),
              });
            }}
            value={filters?.orderNumber}
            style={{ flex: 1, maxWidth: isSaleMng ? '25%' : '30%' }}
          />

          <RangeDatePickerContainer
            style={{ width: isSaleMng ? '25%' : '30%' }}
          >
            <RangeDatePickerCustom
              placeholder={
                translations ? translations['b2b.txt.date-order'] : ''
              }
              minDate={null}
              isClearable
              startDateInit={filters?.orderDateFrom?.toDate()}
              endDateInit={filters?.orderDateTo?.toDate()}
              onChange={([start, end]) => {
                setFilters?.({
                  ...filters,
                  orderDateFrom: start ? moment(start) : null,
                  orderDateTo: end ? moment(end) : null,
                });
              }}
              maxDate={new Date()}
            />
          </RangeDatePickerContainer>

          {isSaleMng && (
            <StyledSelect
              filterOption={(input, option) =>
                (convertVItoEN(option?.label) ?? '').includes(
                  convertVItoEN(input),
                )
              }
              showSearch
              isFocus
              value={filters?.agentId}
              suffixIcon={<ArrowDownIcon />}
              placeholder={translations ? translations['b2b.txt.orderer'] : ''}
              onChange={val =>
                setFilters?.({ ...filters, agentId: val as string })
              }
              options={dataAgent}
              allowClear
              style={{ flex: 1, maxWidth: '25%' }}
            />
          )}
          <StyledSelect
            filterOption={(input, option) =>
              (convertVItoEN(option?.label) ?? '').includes(
                convertVItoEN(input),
              )
            }
            showSearch
            isFocus
            value={filters?.comboType}
            suffixIcon={<ArrowDownIcon />}
            style={{ flex: 1, maxWidth: '25%' }}
            placeholder={translations ? translations['b2b.txt.comboType'] : ''}
            onChange={val =>
              setFilters?.({
                ...filters,
                comboType: val as HOLIDAY_COMBO_TYPES,
              })
            }
            options={COMBO_TYPE_OPTIONS.map(i => ({
              value: i.value,
              label: translations?.[i.labelKey] ?? '',
            }))}
            allowClear
          />

          <StyledSelect
            filterOption={(input, option) =>
              (convertVItoEN(option?.label) ?? '').includes(
                convertVItoEN(input),
              )
            }
            showSearch
            isFocus
            value={filters?.searchParkID}
            suffixIcon={<ArrowDownIcon />}
            style={{ flex: 1, maxWidth: '25%' }}
            placeholder={translations ? translations['b2c.txt.park'] : ''}
            onChange={val =>
              setFilters?.({
                ...filters,
                searchParkID: val as string,
              })
            }
            options={travelLocation}
            allowClear
          />
        </StyledStack>
        <StyledStack columnGap={'18px'} justifyContent={'flex-start'}>
          <StyledSelect
            filterOption={(input, option) =>
              (convertVItoEN(option?.label) ?? '').includes(
                convertVItoEN(input),
              )
            }
            showSearch
            isFocus
            value={filters?.orderSource}
            suffixIcon={<ArrowDownIcon />}
            placeholder={translations ? translations['b2b.txt.source'] : ''}
            onChange={val =>
              setFilters?.({ ...filters, orderSource: val as ORDER_SOURCES })
            }
            options={ORDER_SOURCE_OPTIONS.map(i => ({
              value: i.value,
              label: translations?.[i.labelKey] ?? '',
            }))}
            allowClear
            style={{ flex: 1, maxWidth: isSaleMng ? '25%' : '30%' }}
          />
          <StyledSelect
            filterOption={(input, option) =>
              (convertVItoEN(option?.label) ?? '').includes(
                convertVItoEN(input),
              )
            }
            showSearch
            isFocus
            value={filters?.paymentMethod}
            suffixIcon={<ArrowDownIcon />}
            placeholder={translations ? translations['b2c.txt.pttt'] : ''}
            onChange={val =>
              setFilters?.({ ...filters, paymentMethod: val as number })
            }
            options={lovPaymentMethod}
            allowClear
            style={{ flex: 1, maxWidth: isSaleMng ? '25%' : '30%' }}
          />
          {tabRoute === TAB_ORDER_MANAGEMENT.THANH_CONG && (
            <StyledSelect
              filterOption={(input, option) =>
                (convertVItoEN(option?.label) ?? '').includes(
                  convertVItoEN(input),
                )
              }
              showSearch
              isFocus
              value={filters?.issueTicket}
              suffixIcon={<ArrowDownIcon />}
              placeholder={
                translations ? translations['b2b.txt.ticketStatus'] : ''
              }
              onChange={val =>
                setFilters?.({ ...filters, issueTicket: val as ISSUE_TICKET })
              }
              options={ISSUE_TICKET_OPTIONS.map(i => ({
                value: i.value,
                label: translations?.[i.labelKey] ?? '',
              }))}
              allowClear
              style={{ flex: 1, maxWidth: isSaleMng ? '25%' : '30%' }}
            />
          )}

          <StyledButton
            bgColor="white"
            border="1px solid #F8B117"
            textColor="#F8B117"
            style={{ flex: 1, height: 44, maxWidth: isSaleMng ? '25%' : '30%' }}
            onClick={() => {
              const data = {
                // search: filters?.orderNumber || undefined,
                // park: filters?.searchParkID,
                ...filters,
                page: 1,
                orderDateFrom: filters?.orderDateFrom?.format('YYYY-MM-DD'),
                orderDateTo:
                  filters?.orderDateTo?.format('YYYY-MM-DD') ??
                  filters?.orderDateFrom?.format('YYYY-MM-DD'),
                // limit: 20,
              };
              searchSuccess.current?.search(data);
              searchPendingPayment.current?.search(data);
              searchCancel.current?.search(data);
            }}
          >
            {translations ? translations['b2c.txt.search'] : ''}
          </StyledButton>
        </StyledStack>
      </StyledStack>
    </Form>
  );
};

const MobileTabletSearchComponent = (
  props: SearchComponentProps & {
    setActiveKeyTab: (val: TAB_ORDER_MANAGEMENT) => void;
    disableExportPdf: boolean;
  },
) => {
  const {
    setActiveKeyTab,
    searchCancel,
    searchSuccess,
    searchPendingPayment,
    handleExportExcel,
    preventApiCall,
    disableExportPdf,
  } = props;
  const translations = useSelector(selectTranslations);
  const orderCount = useSelector(selectOrderCount);
  const location = useLocation();
  const history = useHistory();
  const href = window.location.href;
  const searchParams = new URL(href).searchParams;
  const tabRoute =
    (location.state as any)?.targetTab ||
    searchParams.get('route') ||
    TAB_ORDER_MANAGEMENT.CHO_THANH_TOAN;
  const [tab, setTab] = useState(tabRoute);
  const [menuVisible, setMenuVisible] = useState(false);
  const { device } = useWindowSize();
  const [loading, setLoading] = useState(false);

  const productListCached = useRef<any>([]);
  const orderedListCached = useRef<any>([]);
  const allocatedListCached = useRef<any>([]);

  return (
    <Form
      style={{
        marginBottom: 16,
        display: 'flex',
      }}
    >
      <div
        style={{
          marginRight: 8,
          width: device !== 'mobile' ? '220px' : '186px',
        }}
      >
        <MobileStyledSelect
          value={tab}
          onChange={val => {
            if (val === TAB_ORDER_MANAGEMENT.THANH_CONG) {
              searchSuccess.current?.search({});
            } else if (val === TAB_ORDER_MANAGEMENT.CHO_THANH_TOAN) {
              searchPendingPayment.current?.search({});
            } else if (val === TAB_ORDER_MANAGEMENT.DA_HUY) {
              searchCancel.current?.search({});
            }
            setTab(val as string);
            setActiveKeyTab(val as TAB_ORDER_MANAGEMENT);
            history.push(`?route=${val}`);
          }}
          suffixIcon={<ArrowDownIcon />}
          style={{ width: '100%' }}
          options={[
            {
              value: TAB_ORDER_MANAGEMENT.THANH_CONG,
              label:
                (translations ? translations['b2c.txt.success'] : '') +
                ' (' +
                (orderCount?.success ?? 0) +
                ')',
            },
            {
              value: TAB_ORDER_MANAGEMENT.CHO_THANH_TOAN,
              label:
                (translations ? translations['b2c.txt.pending'] : '') +
                ' (' +
                (orderCount?.paymentPending ?? 0) +
                ')',
            },
            {
              value: TAB_ORDER_MANAGEMENT.DA_HUY,
              label:
                (translations ? translations['b2c.txt.cancelled'] : '') +
                ' (' +
                (orderCount?.cancel ?? 0) +
                ')',
            },
          ]}
        />
      </div>
      <div
        style={{
          display: 'flex',
          flex: device === 'mobile' ? 1 : undefined,
          width: device === 'mobile' ? '55%' : '85%',
          justifyContent: 'flex-end',
        }}
      >
        <StyledStack justifyContent={'flex-end'}>
          <Dropdown
            visible={menuVisible}
            trigger={['click']}
            onVisibleChange={visible => setMenuVisible(visible)}
            getPopupContainer={trigger => trigger.parentNode as HTMLElement}
            overlayStyle={{ zIndex: 3 }}
            destroyPopupOnHide
            overlay={
              <MobileSearchOverlay
                {...props}
                setMenuVisible={setMenuVisible}
                preventApiCall={preventApiCall}
                productListCached={productListCached}
                orderedListCached={orderedListCached}
                allocatedListCached={allocatedListCached}
              />
            }
          >
            <StyledButton
              bgColor="#fff"
              style={{
                border: '1px solid #EDEDED',
                borderRadius: 10,
                width: 41,
                height: 41,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 0,
              }}
            >
              <FilterIcon width={16} height={16} color="#000" />
            </StyledButton>
          </Dropdown>
          <StyledButton
            bgColor="#fff"
            style={{
              border: '1px solid #EDEDED',
              borderRadius: 10,
              width: 41,
              height: 41,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 0,
              marginLeft: 8,
            }}
            onClick={() => !disableExportPdf && handleExportExcel?.()}
          >
            {loading ? (
              <LoadingOutlined
                style={{ fontSize: 16, color: '#F8B117' }}
                spin
              />
            ) : (
              <StyledExportTicketIcon
                active={!disableExportPdf}
                width={16}
                height={16}
              />
            )}
          </StyledButton>
        </StyledStack>
      </div>
    </Form>
  );
};

const MobileSearchOverlay = ({
  tab,
  travelLocation,
  searchSuccess,
  searchPendingPayment,
  searchCancel,
  setMenuVisible,
  filters,
  setFilters,
  listOrderType,
  preventApiCall,
  productListCached,
  orderedListCached,
  allocatedListCached,
}: SearchComponentProps & {
  setMenuVisible: (show: boolean) => void;
  preventApiCall: boolean;
  productListCached: MutableRefObject<any[]>;
  orderedListCached: MutableRefObject<any[]>;
  allocatedListCached: MutableRefObject<any[]>;
}) => {
  const translations = useSelector(selectTranslations);
  const infoUser = useSelector(selectInfoUser);
  const location = useLocation();
  const href = window.location.href;
  const searchParams = new URL(href).searchParams;
  const tabRoute =
    (location.state as any)?.targetTab ||
    searchParams.get('route') ||
    TAB_ORDER_MANAGEMENT.CHO_THANH_TOAN;
  const [dataAgent, setDataAgent] = useState<any>(orderedListCached.current);
  const [lovPaymentMethod, setLOVPaymentMethod] = useState<any[]>([]);
  // const listStatus = [
  //   { value: '', label: translations?.['b2b.text.all'] },
  //   {
  //     id: 2,
  //     label: translations?.['b2b.txt.ticket-exporting'],
  //     value: 'SyncVGS',
  //   },
  //   {
  //     id: 3,
  //     label: translations?.['b2b.txt.ticket-exported'],
  //     value: 'success',
  //   },
  // ];

  const isSaleMng =
    infoUser?.role_code === Permission.ROLE_SALE_MANAGER ||
    infoUser?.role_code === Permission.ROLE_SALE_SHG;

  const getDataAgent = useCallback(async () => {
    try {
      const { data } = await getDataAgentApi();
      if (!isEmpty(data?.data)) {
        const resAgents = data?.data.map((item: any) => {
          return {
            label: item.name,
            value: item.id,
          };
        });
        const resAgentsEx: any = isSaleMng
          ? [
              {
                value: '',
                label: translations?.['b2b.text.all'],
              },
              ...resAgents,
            ]
          : resAgents;
        setDataAgent(resAgentsEx);
        orderedListCached.current = resAgentsEx;
      }
    } catch (error) {}
  }, [isSaleMng, translations, orderedListCached]);

  const getPaymentMethod = useCallback(async () => {
    try {
      const { data } = await getLOVpaymentMethod();
      if (!isEmpty(data?.data)) {
        const lovpayment = data?.data.map((item: any) => {
          return {
            label: item.name,
            value: item.id,
          };
        });
        setLOVPaymentMethod([
          {
            value: '',
            label: translations?.['b2b.text.all'],
          },
          ...lovpayment,
        ]);
      }
    } catch (error) {}
  }, [translations]);

  useEffect(() => {
    if (preventApiCall) return;
    getDataAgent();
    getPaymentMethod();
  }, [getDataAgent, getPaymentMethod]);

  return (
    <div
      style={{
        padding: '16px',
        backgroundColor: 'white',
        borderRadius: 8,
        boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <StyledSearchInput
        placeholder={translations ? translations['b2c.txt.orderNumber'] : ''}
        style={{
          marginBottom: 8,
          width: '100%',
        }}
        value={filters?.orderNumber}
        onChange={e =>
          setFilters?.({
            ...filters,
            orderNumber: e.target.value ?? '',
          })
        }
        onBlur={() => {
          setFilters?.({
            ...filters,
            orderNumber: filters?.orderNumber?.trim(),
          });
        }}
      />
      <RangeDatePickerContainer style={{ marginBottom: 8, width: 267 }}>
        <RangeDatePickerCustom
          placeholder={translations ? translations['b2b.txt.date-order'] : ''}
          minDate={null}
          isClearable
          startDateInit={filters?.orderDateFrom?.toDate()}
          endDateInit={filters?.orderDateTo?.toDate()}
          onChange={([start, end]) => {
            setFilters?.({
              ...filters,
              orderDateFrom: start ? moment(start) : null,
              orderDateTo: end ? moment(end) : null,
            });
          }}
          onCalendarClose={() => {
            setFilters?.({
              ...filters,
              orderDateTo: filters?.orderDateTo ?? filters?.orderDateFrom,
            });
          }}
        />
      </RangeDatePickerContainer>

      {isSaleMng && (
        <StyledSelect
          filterOption={(input, option) =>
            (option?.label?.toLowerCase() ?? '').includes(input?.toLowerCase())
          }
          showSearch
          isFocus
          value={filters?.agentId}
          suffixIcon={<ArrowDownIcon />}
          placeholder={translations ? translations['b2b.txt.orderer'] : ''}
          onChange={val => setFilters?.({ ...filters, agentId: val as string })}
          options={dataAgent}
          allowClear
          style={{
            marginBottom: 8,
            width: 267,
          }}
          dropdownStyle={{ zIndex: 4 }}
        />
      )}
      <StyledSelect
        filterOption={(input, option) =>
          (option?.label?.toLowerCase() ?? '').includes(input?.toLowerCase())
        }
        showSearch
        isFocus
        value={filters?.comboType}
        suffixIcon={<ArrowDownIcon />}
        placeholder={translations ? translations['b2b.txt.comboType'] : ''}
        onChange={val =>
          setFilters?.({ ...filters, orderSource: val as ORDER_SOURCES })
        }
        options={COMBO_TYPE_OPTIONS.map(i => ({
          value: i.value,
          label: translations?.[i.labelKey] ?? '',
        }))}
        allowClear
        style={{
          marginBottom: 8,
          width: 267,
        }}
        dropdownStyle={{ zIndex: 4 }}
      />
      <StyledSelect
        filterOption={(input, option) =>
          (option?.label?.toLowerCase() ?? '').includes(input?.toLowerCase())
        }
        showSearch
        isFocus
        value={filters?.orderSource}
        suffixIcon={<ArrowDownIcon />}
        placeholder={translations ? translations['b2b.txt.source'] : ''}
        onChange={val =>
          setFilters?.({ ...filters, orderSource: val as ORDER_SOURCES })
        }
        options={ORDER_SOURCE_OPTIONS.map(i => ({
          value: i.value,
          label: translations?.[i.labelKey] ?? '',
        }))}
        allowClear
        style={{
          marginBottom: 8,
          width: 267,
        }}
        dropdownStyle={{ zIndex: 4 }}
      />
      <StyledSelect
        filterOption={(input, option) =>
          (option?.label?.toLowerCase() ?? '').includes(input?.toLowerCase())
        }
        showSearch
        isFocus
        value={filters?.paymentMethod}
        suffixIcon={<ArrowDownIcon />}
        placeholder={translations ? translations['b2c.txt.pttt'] : ''}
        onChange={val =>
          setFilters?.({ ...filters, paymentMethod: val as number })
        }
        options={lovPaymentMethod}
        allowClear
        style={{
          marginBottom: 8,
          width: 267,
        }}
        dropdownStyle={{ zIndex: 4 }}
      />
      {tabRoute === TAB_ORDER_MANAGEMENT.THANH_CONG && (
        <StyledSelect
          filterOption={(input, option) =>
            (option?.label?.toLowerCase() ?? '').includes(input?.toLowerCase())
          }
          showSearch
          isFocus
          value={filters?.issueTicket}
          suffixIcon={<ArrowDownIcon />}
          placeholder={translations ? translations['b2b.txt.ticketStatus'] : ''}
          onChange={val =>
            setFilters?.({ ...filters, issueTicket: val as ISSUE_TICKET })
          }
          options={ISSUE_TICKET_OPTIONS.map(i => ({
            value: i.value,
            label: translations?.[i.labelKey] ?? '',
          }))}
          allowClear
          style={{
            marginBottom: 8,
            width: 267,
          }}
          dropdownStyle={{ zIndex: 4 }}
        />
      )}
      <StyledSelect
        filterOption={(input, option) =>
          (option?.label?.toLowerCase() ?? '').includes(input?.toLowerCase())
        }
        showSearch
        isFocus
        value={filters?.searchParkID}
        suffixIcon={<ArrowDownIcon />}
        style={{ width: 267, marginBottom: 8 }}
        placeholder={translations ? translations['b2c.txt.park'] : ''}
        onChange={val =>
          setFilters?.({ ...filters, searchParkID: val as string })
        }
        options={travelLocation}
        dropdownStyle={{ zIndex: 4 }}
        allowClear
      />

      <StyledButton
        bgColor="white"
        border="1px solid #F8B117"
        textColor="#F8B117"
        width={'100%'}
        height={'44px'}
        onClick={() => {
          const data = {
            // search: filters?.orderNumber || undefined,
            // park: filters?.searchParkID,
            ...filters,
            page: 1,
            orderDateFrom: filters?.orderDateFrom?.format('YYYY-MM-DD'),
            orderDateTo:
              filters?.orderDateTo?.format('YYYY-MM-DD') ??
              filters?.orderDateFrom?.format('YYYY-MM-DD'),
            // limit: 20,
          };
          searchSuccess.current?.search(data);
          searchPendingPayment.current?.search(data);
          searchCancel.current?.search(data);
        }}
      >
        {translations ? translations['b2c.txt.search'] : ''}
      </StyledButton>
    </div>
  );
};
export type ListOrderViewRef = {
  search: (params: Partial<I_PayloadGetListOrder>) => void;
  getCurrentSearchOpt: () => I_PayloadGetListOrder;
};

const OrderManagement = () => {
  const dispatch = useDispatch();
  const translations = useSelector(selectTranslations);
  const searchSuccess = useRef<ListOrderViewRef>(null);
  const searchPendingPayment = useRef<ListOrderViewRef>(null);
  const searchCancel = useRef<ListOrderViewRef>(null);

  const { device } = useWindowSize();
  const location = useLocation();
  const href = window.location.href;
  const searchParams = new URL(href).searchParams;
  const tabRoute =
    (location.state as any)?.targetTab ||
    searchParams.get('route') ||
    TAB_ORDER_MANAGEMENT.CHO_THANH_TOAN;
  const [activeKeyTab, setActiveKeyTab] =
    useState<TAB_ORDER_MANAGEMENT>(tabRoute);
  const [loading, setLoading] = useState(false);
  const [loadingExcel, setLoadingExcel] = useState(false);
  const orderCount: any = useSelector(selectOrderCount);
  const [filters, setFilters] = useState<Partial<FilterDataView>>({
    orderDateFrom: moment().startOf('month'),
    orderDateTo: moment(),
  });
  const { onOpenDialogNoti, onCloseDialogNoti } = useGlobalFunction();
  const history = useHistory();
  useHomeSlice(); //load thông tin công viên
  const infoUser: any = useSelector(selectInfoUser);

  const listPark = useSelector(selectListPark);
  const listOrderType = [
    { value: '', label: translations?.['b2b.text.all'] },
    { value: 'new', label: translations?.['b2b.txt.type-new'] },
    {
      label: translations?.['b2b.txt.type-exchange'],
      value: 'upgrade',
    },
    {
      label: translations?.['b2b.txt.type-cancel'],
      value: 'return',
    },
  ];

  const handleExportExcel = async () => {
    try {
      if (!(orderCountValue > 0)) return;
      setLoadingExcel(true);
      const data = (() => {
        switch (activeKeyTab) {
          case TAB_ORDER_MANAGEMENT.THANH_CONG:
            return searchSuccess.current?.getCurrentSearchOpt();
          case TAB_ORDER_MANAGEMENT.CHO_THANH_TOAN:
            return searchPendingPayment.current?.getCurrentSearchOpt();
          case TAB_ORDER_MANAGEMENT.DA_HUY:
            return searchCancel.current?.getCurrentSearchOpt();
        }
      })();
      const requestTemp = {
        ...data,
        ...(data?.orderState === 'success' && data.issueTicket
          ? { issueTicket: data.issueTicket }
          : { issueTicket: undefined }),
      };
      const resExportExcel = await exportListOrderExcelApi(
        cleanObject(requestTemp ?? {}),
      );
      setLoadingExcel(false);
      if (resExportExcel?.data?.url) {
        window.location.href = resExportExcel?.data?.url;
        // const newFilters: Partial<FilterDataView> = {
        //   successState:
        //     searchSuccess.current?.getCurrentSearchOpt().successState,
        //   orderNumber: data?.search,
        //   searchParkID: data?.park,
        //   orderDateFrom: data?.orderDateFrom
        //     ? moment(data?.orderDateFrom)
        //     : undefined,
        //   orderDateTo:
        //     data?.orderDateTo ?? data?.orderDateFrom
        //       ? moment(data?.orderDateTo ?? data?.orderDateFrom)
        //       : undefined,
        //   agentId: data?.agentId,
        // };
        //   setFilters(cleanObject(newFilters));
      } else if (resExportExcel?.data?.message) {
        onOpenDialogNoti({
          type: 'SUCCESS',
          content: resExportExcel?.data?.message ?? '',
          isShow: true,
          title: '',
          onCloseDialog: onCloseDialogNoti,
        });
      } else {
        throw resExportExcel;
      }
    } catch (error: any) {
      onOpenDialogNoti({
        type: 'ERROR',
        content: error?.message ?? '',
        isShow: true,
        title: '',
        onCloseDialog: onCloseDialogNoti,
      });
    } finally {
      setLoadingExcel(false);
    }
  };

  const travelLocation = useMemo(() => {
    return [
      ...[{ value: '', label: translations?.['b2b.text.all'] }],
      ...listPark?.map(item => ({
        value: `${item.id}`,
        label: item.name,
      })),
    ];
  }, [listPark, translations]);

  useEffect(() => {
    dispatch(GET_PARKS()); //lấy danh sách công viên
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const orderCountValue = useMemo(() => {
    switch (activeKeyTab) {
      case TAB_ORDER_MANAGEMENT.THANH_CONG:
        return orderCount?.success;
      case TAB_ORDER_MANAGEMENT.CHO_THANH_TOAN:
        return orderCount?.paymentPending;
      case TAB_ORDER_MANAGEMENT.DA_HUY:
        return orderCount?.cancel ?? 0;
    }
  }, [
    activeKeyTab,
    orderCount?.cancel,
    orderCount?.paymentPending,
    orderCount?.success,
  ]);

  useEffect(() => {
    // if cancel order at page /ticket-refund/info,
    // then back to this component -> show msg cancel successfully
    const showCancelOrderSuccessMsg = () => {
      const sessionMsg = JSON.parse(
        sessionStorage.getItem(SESSION_MESSAGE) ?? '{}',
      );
      sessionStorage.removeItem(SESSION_MESSAGE);
      if (sessionMsg?.message) {
        onOpenDialogNoti({
          type: sessionMsg?.type ?? 'SUCCESS',
          isShow: true,
          title: '',
          content: sessionMsg?.message,
          buttons: [],
          closable: true,
          maskClosable: false,
          onCloseDialog: () => {
            onCloseDialogNoti();
          },
        });
      }
    };

    showCancelOrderSuccessMsg();
  }, [onCloseDialogNoti, onOpenDialogNoti]);

  useEffect(() => {
    if (location?.search?.startsWith('?screen=detail')) return;
    const route = searchParams.get('route');
    const paramRoute = (location.state as any)?.targetTab;
    if (paramRoute) {
      history.push(`?route=${paramRoute}`);
    } else {
      setActiveKeyTab(
        (route as TAB_ORDER_MANAGEMENT) || TAB_ORDER_MANAGEMENT.CHO_THANH_TOAN,
      );
    }
  }, [activeKeyTab, history, location.state, searchParams, location.search]);

  const overviewComponent = (
    <LoadingContainer loading={loading || loadingExcel}>
      <div>
        {device === 'desktop' && (
          <div>
            <DesktopSearchComponent
              preventApiCall={device !== 'desktop'}
              searchCancel={searchCancel}
              searchPendingPayment={searchPendingPayment}
              searchSuccess={searchSuccess}
              travelLocation={travelLocation}
              setFilters={setFilters}
              filters={filters}
              tab={activeKeyTab}
              listOrderType={listOrderType}
            />
          </div>
        )}
        {(device === 'mobile' || device === 'tablet') && (
          <div>
            <MobileTabletSearchComponent
              preventApiCall={!(device === 'mobile' || device === 'tablet')}
              setActiveKeyTab={setActiveKeyTab}
              searchCancel={searchCancel}
              searchPendingPayment={searchPendingPayment}
              searchSuccess={searchSuccess}
              travelLocation={travelLocation}
              setFilters={setFilters}
              filters={filters}
              tab={activeKeyTab}
              handleExportExcel={handleExportExcel}
              listOrderType={listOrderType}
              disableExportPdf={!(orderCountValue > 0)}
            />
          </div>
        )}
      </div>
      <div>
        <StyledTabs
          onChange={key => {
            if (key === TAB_ORDER_MANAGEMENT.THANH_CONG) {
              searchSuccess.current?.search({});
            } else if (key === TAB_ORDER_MANAGEMENT.CHO_THANH_TOAN) {
              searchPendingPayment.current?.search({});
            } else if (key === TAB_ORDER_MANAGEMENT.DA_HUY) {
              searchCancel.current?.search({});
            }
            setActiveKeyTab(key as TAB_ORDER_MANAGEMENT);
            history.push(`?route=${key}`);
          }}
          activeKey={activeKeyTab}
          tabBarStyle={{
            display: device !== 'desktop' ? 'none' : undefined,
            margin: '10px 0',
          }}
          tabBarExtraContent={{
            right: (
              <div style={{ paddingBottom: 8 }}>
                <DownLoadExcel
                  disabled={!(orderCountValue > 0)}
                  onClick={handleExportExcel}
                />
              </div>
            ),
          }}
        >
          <StyledTabs.TabPane
            forceRender
            tab={`${translations ? translations['b2c.txt.success'] : ''} (${
              orderCount?.success ?? 0
            })`}
            key={TAB_ORDER_MANAGEMENT.THANH_CONG}
          >
            <ListOrderSuccess
              ref={searchSuccess}
              activeKeyTab={activeKeyTab}
              loading={loading}
              setLoading={setLoading}
            />
          </StyledTabs.TabPane>
          <StyledTabs.TabPane
            forceRender
            tab={`${translations ? translations['b2c.txt.pending'] : ''} (${
              orderCount?.paymentPending ?? 0
            })`}
            key={TAB_ORDER_MANAGEMENT.CHO_THANH_TOAN}
          >
            <ListOrderPending
              ref={searchPendingPayment}
              activeKeyTab={activeKeyTab}
              loading={loading}
              setLoading={setLoading}
            />
          </StyledTabs.TabPane>
          <StyledTabs.TabPane
            forceRender
            tab={`${translations ? translations['b2c.txt.cancelled'] : ''} (${
              orderCount?.cancel ?? 0
            })`}
            key={TAB_ORDER_MANAGEMENT.DA_HUY}
          >
            <ListOrderCancel
              ref={searchCancel}
              activeKeyTab={activeKeyTab}
              loading={loading}
              setLoading={setLoading}
            />
          </StyledTabs.TabPane>
        </StyledTabs>
      </div>
    </LoadingContainer>
  );

  return (
    <Layout
      title={
        translations
          ? translations['b2b.orderManagement.orderList'] ??
            'Lịch sử đơn hàng vé Combo holiday'
          : ''
      }
      menuActive={ACCOUNT_MNG_MENU.ORDER_MANAGEMENT}
    >
      {overviewComponent}
    </Layout>
  );
};

export default OrderManagement;

const StyledExportTicketIcon = styled(ExportTicketIconInactive)<{
  active: boolean;
}>`
  path {
    fill: ${props => (props.active ? '#FAB317' : '#d9d9d9')};
  }
`;

const RangeDatePickerContainer = styled.div`
  width: 25%;
  .range-picker-container {
    width: 100%;
  }
  .react-datepicker__close-icon {
    right: 5px;
  }
  .date-picker {
    height: 44px;
  }
`;
